import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-custom-table-row',
  templateUrl: './custom-table-row.component.html',
  styleUrls: ['./custom-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTableRowComponent {
  constructor() {}
}
